import { Component, Input, OnInit } from '@angular/core';
import {
    COLUMNS_NUMBER_DEFAULT,
    MAX_COLUMNS_COUNT_DEFAULT,
    ROWS_NUMBER_DEFAULT,
    SPLIT_COLUMN_BY_LINE_DEFAULT,
    SPLIT_ROWS_BY_LINE_DEFAULT,
} from '../../../constants/const';
import { MdrDashboardsService } from '../../../services/mdr-dashboards.service';

@Component({
    selector: 'app-mdr-loader',
    templateUrl: './mdr-loader.component.html',
    styleUrls: ['./mdr-loader.component.scss'],
    standalone: false,
})
export class MdrLoaderComponent implements OnInit {
    /**
     * @var rows: number
     * How many lines of loaders we want to display
     */
    @Input() public rows = ROWS_NUMBER_DEFAULT;

    /**
     * @var columns: number
     * How many columns of loaders we want to display
     */
    @Input() public columns = COLUMNS_NUMBER_DEFAULT;

    /**
     * @var maxColumnsCount: number
     * We need to constrain the maximum amount of columns that can be generated with the 'columns' property because the
     * column width is calculated by dividing 100% to the number of columns. We don't want to have unnatural values
     * for the 'columns' property.
     */
    @Input() public maxColumnsCount = MAX_COLUMNS_COUNT_DEFAULT;

    /**
     * @var splitColumnByLine: boolean
     * Setting this to 'true' will display a vertical line between the loader columns
     */
    @Input() public splitColumnByLine = SPLIT_COLUMN_BY_LINE_DEFAULT;

    /**
     * @var splitRowsByLine: boolean
     * Setting this to 'true' will display a vertical line between the loader rows
     */
    @Input() public splitRowsByLine = SPLIT_ROWS_BY_LINE_DEFAULT;

    public columnsCount: number;
    public loaderClass: string;
    public rowsArr: number[] = [];
    public columnsArr: number[] = [];

    constructor(public mdrDashboardsService: MdrDashboardsService) {}

    public ngOnInit() {
        this.columnsCount = this.mdrDashboardsService.limitValueToMinMax(this.columns, 1, this.maxColumnsCount);
        this.loaderClass = this.columnsCount > 1 ? 'has-columns' : '';
        for (let i = 0; i < this.rows; i++) {
            this.rowsArr.push(i);
        }

        for (let i = 0; i < this.columns; i++) {
            this.columnsArr.push(i);
        }
    }
}
